<template>
  <div class="container index">
    <!-- banner -->
    <BannerSwiper class="wow fadeInUp animated"></BannerSwiper>
    <!-- 产品中心 -->
    <ProductCenter class="wow fadeInUp animated"></ProductCenter>
    <!-- 品牌家族 -->
    <BrandFamily class="wow fadeInUp animated"></BrandFamily>
    <!-- 公司简介 -->
    <CompanyProfile class="wow fadeInUp animated"></CompanyProfile>
    <!-- 新闻动态 -->
    <NewsCon class="wow fadeInUp animated"></NewsCon>
    <!-- 合作伙伴 -->
    <PartnerCon class="wow fadeInUp animated"></PartnerCon>
  </div>
</template>

<script>
import BannerSwiper from "@/components/index/BannerSwiper.vue";
import BrandFamily from "@/components/index/BrandFamily.vue";
import CompanyProfile from "@/components/index/CompanyProfile.vue";
import ProductCenter from "@/components/index/ProductCenter.vue";
import NewsCon from "@/components/index/NewsCon.vue";
import PartnerCon from "@/components/index/PartnerCon.vue";

if (process.browser) {
  var { WOW } = require("wowjs");
}
export default {
  components: {
    CompanyProfile,
    ProductCenter,
    NewsCon,
    PartnerCon,
    BannerSwiper,
    BrandFamily
  },
  data() {
    return {};
  },
  mounted() {
    if (process.browser) {
      new WOW({
        live: false,
        offset: 0,
      }).init();
    }
  },
};
</script>
<style lang="scss">
.indexMain {
  width: 72.92vw;
  margin: 0 auto;
  .title {
    width: 100%;
    height: 3.13vw;
    margin: 2.08vw 0 1.56vw;
    position: relative;
    .t_cn {
      height: 3.13vw;
      font-size: 1.25vw;
      line-height: 3.13vw;
      color: #333333;
      text-align: center;
    }
    .t_en {
      width: 100%;
      height: 4.17vw;
      font-size: 3.75vw;
      font-weight: bold;
      color: #666666;
      opacity: 0.1;
      text-align: center;
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -2.08vw 0 0 -36.46vw;
    }
  }
}
@media (min-width: 1920px) {
  .indexMain {
    width: 1400px;
    margin: 0 auto;
    .title {
      width: 100%;
      height: 60px;
      margin: 40px 0 30px;
      position: relative;
      .t_cn {
        height: 60px;
        font-size: 24px;
        line-height: 60px;
        color: #333333;
        text-align: center;
      }
      .t_en {
        width: 100%;
        height: 80px;
        font-size: 72px;
        font-weight: bold;
        color: #666666;
        opacity: 0.1;
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -40px 0 0 -700px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
// @import "~/assets/css/index.css";
.index {
  // overflow: hidden;
  padding: 0 0 60px 0;
}
</style>